import React, { useContext } from 'react'
import { GelScreenDetectorContext } from '@tal-gel/components'

import Logo from '../../components/Logo/Logo'
import { Header as HeaderComponent, HeaderWrapper } from '../Shared/Components'

const Header = ({ demo }) => {
  const { screen, isLargerThanSmScreen } = useContext(GelScreenDetectorContext)

  return (
    <HeaderComponent>
      <HeaderWrapper>
        <Logo
          version='full'
          height={isLargerThanSmScreen(screen) ? '37px' : '22px'}
        />
        {!demo && isLargerThanSmScreen(screen) && (
          <Logo version='cbus' ml={6} />
        )}
      </HeaderWrapper>
    </HeaderComponent>
  )
}

export default Header
